import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import i18n from '../../i18n';
import _actions from '../../actions';
import ThirdPartyConnect from './ThirdPartyConnect';
import constants from '../../constants';
import InputDialog from '../common/InputDialog';
import YesNoDialog from '../common/YesNoDialog';

class YouTubeSermons extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogOpened: false,
        };
    }

    openMediaDialog = () => {
        this.clearMediaAlerts();
        this.setState({
            dialogOpened: true,
            dialogDescription: i18n.t('modules.sermons.youtube.description'),
            dialogPlaceholder: i18n.t('modules.sermons.youtube.placeholder'),
            dialogTitle: i18n.t('modules.sermons.youtube.title'),
            dialogActionName: i18n.t('modules.sermons.youtube.action'),
            dialogIconPath: 'M63.3252635,9.7 C63.3252635,9.7 62.7005075,5.3 60.7762593,3.35 C58.3522063,0.8 55.6282702,0.8 54.353768,0.65 C45.432253,0 32.012495,0 32.012495,0 L31.987505,0 C31.987505,0 18.567747,0 9.59625148,0.65 C8.34673955,0.8 5.6228036,0.8 3.17376025,3.35 C1.27450215,5.3 0.649746192,9.7 0.649746192,9.7 C0.649746192,9.7 0,14.9 0,20.075 L0,24.925 C0,30.1 0.649746192,35.275 0.649746192,35.275 C0.649746192,35.275 1.27450215,39.675 3.1987505,41.625 C5.6228036,44.175 8.82155407,44.1 10.2459976,44.35 C15.3689965,44.85 31.987505,45 31.987505,45 C31.987505,45 45.432253,44.975 54.3787582,44.325 C55.6282702,44.175 58.3522063,44.175 60.8012495,41.625 C62.7254978,39.675 63.3502538,35.275 63.3502538,35.275 C63.3502538,35.275 64,30.1 64,24.925 L64,20.075 C63.9750097,14.9 63.3252635,9.7 63.3252635,9.7 L63.3252635,9.7 Z M25.390082,30.8 L25.390082,12.825 L42.6833267,21.85 L25.390082,30.8 L25.390082,30.8 Z',
            dialogIconFill: 'url(#youtube-a)',
            dialogIconFillRule: 'nonzero',
        });
    };

    importFeedURL = (value) => {
        this.clearMediaAlerts();
        this.props.actions.clearAlert('empty');
        if (value.indexOf('channel') !== -1 || value.indexOf('playlist?list=') !== -1 || value.indexOf('user') !== -1) {
            this.props.updateFields([{ Name: 'mediaType', Value: 1 }, { Name: 'mediaUrl', Value: value.trim() }]);
            this.closeDialog();
        } else {
            this.openYouTubeAlert();
            this.closeDialog();
        }
    };

    openYouTubeAlert = () => {
        const id = 'youtube';
        this.props.actions.addAlert({
            message: i18n.t('modules.sermons.youtube.error'),
            dismissable: true,
            type: 'error',
            view: 'modules/sermons',
            id,
        });
    };

    clearMediaAlerts = () => {
        this.props.actions.clearAlert('youtube');
        this.props.actions.clearAlert('sermons-rss');
        this.props.actions.clearAlert('sermon-media-invalid');
        this.props.actions.clearAlert('empty');
        this.props.actions.clearAlert('vimeo-denied');
    }

    connectClick = () => {
        if (this.props.versions.select.mediaType) {
            this.showDisconnectConfirm();
        }
        this.openMediaDialog();
    };

    showDisconnectConfirm = () => {
        this.setState({
            confirmDisconnect: true,
        });
    };

    closeDialog = () => {
        this.setState({
            dialogOpened: false,
        });
    };

    closeYesNoDialog = () => {
        this.setState({
            confirmDisconnect: false,
            dialogOpened: false,
        });
    };

    handleDisconnect = () => {
        this.props.handleDisconnect();
        this.setState({
            confirmDisconnect: false,
        });
    };

    render() {
        return (
            <div className="YouTube-Sermons">
                {this.state.dialogOpened
                    && (
                        <InputDialog
                            AddAlertAction={this.props.actions.addAlert}
                            Alerts={this.props.alerts}
                            Visible={this.state.dialogOpened}
                            Description={this.state.dialogDescription}
                            Title={this.state.dialogTitle}
                            CloseDialog={this.closeDialog}
                            ActionName={this.state.dialogActionName}
                            Action={this.importFeedURL}
                            Placeholder={this.state.dialogPlaceholder}
                            SVGIconPath={this.state.dialogIconPath}
                            SVGIconFill={this.state.dialogIconFill}
                            SVGIconFillRule={this.state.dialogIconFillRule}
                            Value=""
                        />
                    )}
                {this.state.confirmDisconnect
                    && (
                        <YesNoDialog
                            Message={this.props.versions.select.mediaType === constants.MediaType.find((mt) => { return mt.Name === 'Vimeo'; }).Id ? i18n.t('modules.sermons.vimeo.warning') : i18n.t('modules.sermons.confirm')}
                            ExecuteAction={this.handleDisconnect}
                            CloseDialog={this.closeYesNoDialog}
                            Visible={this.state.confirmDisconnect}
                            title="Disconnect Existing Source?"
                        />
                    )}

                <ThirdPartyConnect
                    ThirdPartyId="youtube"
                    ThirdPartyTitle={i18n.t('modules.sermons.youtube.header')}
                    ThirdPartyIcon="M23.8 3.6s-.2-1.7-1-2.4c-.9-1-1.9-1-2.4-1C17 0 12 0 12 0S7 0 3.6.2c-.5.1-1.5.1-2.4 1-.7.7-1 2.4-1 2.4S0 5.5 0 7.5v1.8c0 1.9.2 3.9.2 3.9s.2 1.7 1 2.4c.9 1 2.1.9 2.6 1 1.9.2 8.2.2 8.2.2s5 0 8.4-.3c.5-.1 1.5-.1 2.4-1 .7-.7 1-2.4 1-2.4s.2-1.9.2-3.9V7.4c0-1.9-.2-3.8-.2-3.8zM9.5 11.5V4.8L16 8.2l-6.5 3.3z"
                    ThirdPartyIconViewBox="0 0 24 17"
                    ThirdPartyFillBox="nonzero"
                    ThirdPartyFill="#444"
                    Connected={this.props.versions.select.mediaType === constants.MediaType.find((mt) => { return mt.Name === 'YouTube'; }).Id}
                    onClick={() => { this.connectClick(); }}
                    onDisconnect={this.showDisconnectConfirm}
                    Value=""
                    DataQA="youtube"
                />

            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(YouTubeSermons);
